const DataTable = ({
  columns = [],
  rows = [],
  getRowKey = (row) => row?.id,
  actions,
  actionsHeader = 'Acciones',
  emptyState = null,
  className = '',
  tableClassName = '',
  rowClassName = '',
  headerClassName = '',
  bodyClassName = '',
}) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return emptyState
  }

  const resolvedColumns = Array.isArray(columns) ? columns : []

  return (
    <div className={`overflow-hidden rounded-xl border border-gray-200 bg-white ${className}`.trim()}>
      <div className="overflow-x-auto">
        <table className={`min-w-full divide-y divide-gray-200 ${tableClassName}`.trim()}>
          <thead className={`bg-gray-50 ${headerClassName}`.trim()}>
            <tr>
              {resolvedColumns.map((column) => (
                <th
                  key={column.key || column.header}
                  scope="col"
                  className={`
                    px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500
                    ${column.headerClassName || ''}
                  `.trim().replace(/\s+/g, ' ')}
                  style={column.width ? { width: column.width } : undefined}
                >
                  {column.header}
                </th>
              ))}
              {actions && (
                <th
                  scope="col"
                  className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide text-gray-500"
                >
                  {actionsHeader}
                </th>
              )}
            </tr>
          </thead>
          <tbody className={`divide-y divide-gray-200 bg-white ${bodyClassName}`.trim()}>
            {rows.map((row) => (
              <tr
                key={getRowKey(row)}
                className={`align-top hover:bg-gray-50/80 ${rowClassName}`.trim()}
              >
                {resolvedColumns.map((column) => (
                  <td
                    key={`${getRowKey(row)}-${column.key || column.header}`}
                    className={`
                      px-4 py-4 text-sm text-gray-700
                      ${column.cellClassName || ''}
                    `.trim().replace(/\s+/g, ' ')}
                  >
                    {column.render ? column.render(row) : row?.[column.key]}
                  </td>
                ))}
                {actions && (
                  <td className="px-4 py-4">
                    <div className="flex justify-end gap-2">
                      {actions(row)}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default DataTable
